<div class="max-w-comfort">
  <p-card>
    <div class="mx-6 my-4">
      <app-patient-info-input title='Myopic' [name]="patientName"
        [ageAtVisit]="calculationResults.serCalcResponse.ethnicities[0].decimalAge" [dateOfLastVisit]="calculationResults.serCalcResponse.ethnicities[0].dateAtLastVisit"></app-patient-info-input>
      @if (reportType === ReportType.ECP && calculationResults.ageWarning) {
      <div class="mb-4">⚠️ {{ 'AGE_WARNING' | translate }}</div>
      } @if (reportType === ReportType.ECP) {
      <app-future-myopia [singleMyopeResults]="calculationResults.singleMyopeResults" [ethnicity]="currentEthnicity"
        (ethnicityChanged)="onEthnicityChange($event)"></app-future-myopia>
      } @else {
      <div class="horiz-bar bg-primary mb-2"></div>
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.WHAT_IS_MYOPIA"></app-parent-paragraph>
      <div class="my-4"></div>
      }

      <app-population-comparison class="mt-6" [serCalcResponse]="calculationResults.serCalcResponse"
        [axialCalcResponse]="calculationResults.axialCalcResponse"
        [treatmentCalcResponse]="calculationResults.treatmentCalcResponse" [ethnicity]="currentEthnicity"
        (ethnicityChanged)="onEthnicityChange($event)"></app-population-comparison>
      @if ((calculationResults.standardProgressionReponse.leftEyeResults ||
      calculationResults.standardProgressionReponse.rightEyeResults)
      && reportType === ReportType.ECP) {
      <app-standard-progression [ethnicity]="currentEthnicity" (ethnicityChanged)="onEthnicityChange($event)"
        [mostMyopicEyeSide]="calculationResults.serCalcResponse.mostMyopicEye ?? calculationResults.axialCalcResponse.mostMyopicEye"
        [ageAtProgression]="calculationResults.standardProgressionReponse.ageAtProgression"
        [leftEyeProgressionStat]="calculationResults.standardProgressionReponse.leftEyeResults"
        [rightEyeProgressionStat]="calculationResults.standardProgressionReponse.rightEyeResults"></app-standard-progression>
      } @if(calculationResults.treatmentCalcResponse.treatmentItems.length > 0 && reportType === ReportType.ECP) {
      <app-myopia-treatments [treatmentCalcResponse]="calculationResults.treatmentCalcResponse"></app-myopia-treatments>
      } @if(reportType === ReportType.Parent){
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.HOW_DO_MY_CHILDS_RESULTS_COMPARE_MYOPIC"></app-parent-paragraph>
      <div class="horiz-bar bg-primary mt-4 mb-4"></div>
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.WHY_DOES_EYE_SIZE_MATTER"></app-parent-paragraph>
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.SLOWDOWN_MYOPIA_MYOPIC"></app-parent-paragraph>
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.WHAT_NEXT_MYOPIC"></app-parent-paragraph>
      <app-parent-paragraph [retestMonths]="retestPeriodMonths"
        [parentParagraphType]="ParentParagraphType.FURTHER_RESOURCES"></app-parent-paragraph>
      }

      <app-credits class="w-full"></app-credits>
    </div>
  </p-card>
</div>